module.exports = __webpack_public_path__ + "img/iso.49ef552f.svg";